import { Stack, Typography } from '@mui/material'

import { useTranslation } from '@/core'
import { Cell, CellFrame } from '@/core/architecture'

type CautionTextCellProps = {
  note: string
}
export const CautionTextCell: Cell<CautionTextCellProps> = ({ note }) => {
  const { t } = useTranslation('firstComeFirstServedDetail')
  return (
    <CellFrame sx={{ pt: 3, pb: '26px' }}>
      <Typography
        variant="h6"
        sx={{ bgcolor: 'grey.50', px: 2, py: 1 }}
        color="text.secondary"
      >
        {t('notes', '注意事項')}
      </Typography>
      <Stack sx={{ pt: 3 }}>
        <Typography component="p" variant="caption" color="text.secondary">
          {note}
        </Typography>
      </Stack>
    </CellFrame>
  )
}
